<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { authComputed } from '@state/helpers'
import Appmenu from './app-menu'
import agronomo from '@/src/services/agronomo'
import Loading from 'vue-loading-overlay'

/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  components: { VuePerfectScrollbar, Appmenu, Loading },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    width: { type: String, required: true },
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      isLoading: false,
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    theme: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'dark':
            document.body.classList.add('left-side-menu-dark')
            document.body.classList.remove('left-side-menu-condensed')
            document.body.classList.remove('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-dark')
            break
        }
      }
    },
    type: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'condensed':
            document.body.classList.add('left-side-menu-condensed')
            document.body.classList.remove('left-side-menu-dark')
            document.body.classList.remove('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-condensed')
            break
        }
      }
    },
    width: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        switch (newVal) {
          case 'boxed':
            document.body.classList.add('left-side-menu-condensed')
            document.body.classList.remove('left-side-menu-dark')
            document.body.classList.add('boxed-layout')
            break
          default:
            document.body.classList.remove('left-side-menu-condensed')
            document.body.classList.remove('boxed-layout')
            break
        }
      }
    },
  },
  mounted() {
    this.checkIfTokenExpired()
  },
  methods: {
    checkIfTokenExpired() {
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .listar(token)
        .then((resposta) => {
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.data) {
            if (error.response.data.message === 'Token expirou') {
              this.$bvModal.show('modal-session')
            }
          }
          this.isLoading = false
        })
    },
  },
}
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="left-side-menu">
    <div class="media user-profile mt-2 mb-2">
      <img src="@assets/images/users/avatar-7.jpg" class="avatar-sm rounded-circle mr-2" alt="WebReceita" />
      <img src="@assets/images/users/avatar-7.jpg" class="avatar-xs rounded-circle mr-2" alt="WebReceita" />

      <div class="media-body">
        <!-- <h6 class="pro-user-name mt-0 mb-0">{{ 'Admin' }}</h6> -->
        <h6 class="pro-user-name mt-0 mb-0">{{ 'Admin' }}</h6>
        <span class="pro-user-desc">Administrator</span>
      </div>
      <b-dropdown variant="black" class="align-self-center" toggle-class="p-0">
        <template v-slot:button-content>
          <feather type="chevron-down" class="align-middle"></feather>
        </template>

        <b-dropdown-item href="/logout" class="notify-item">
          <feather type="log-out" class="icon-dual icon-xs mr-2 align-middle"></feather>
          <span>Logout</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>


    <div class="sidebar-content">
      <VuePerfectScrollbar v-if="!isCondensed" v-once class="slimscroll-menu" :settings="settings">
        <div id="sidebar-menu">

          <Appmenu />
        </div>
      </VuePerfectScrollbar>
      <div v-else id="sidebar-menu">
        <Appmenu />
      </div>
    </div>
    <!-- Sidebar -left -->
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>

    <b-modal :no-close-on-backdrop="true" :hide-header="true" id="modal-session" title="Ops" ok-only
      title-class="font-18">
      <p>Sua sessão expirou, é necessário realizar um novo login para continuar
        utilizando o sistema, por favor click no botão OK.</p>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$router.push({ name: 'logout' })">OK</b-button>
      </template>
    </b-modal>
  </div>

  <!-- Left Sidebar End -->
</template>

<style lang="scss">
.slimscroll-menu {
  height: 100%;
}

.ps>.ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
  width: 6px !important;
}
</style>
